import { useState, useEffect } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import EscMonthlyReportTable from "./EscMonthlyReportTable";
import useLogout from "../../hooks/useLogout";
import { useNavigate } from "react-router-dom";

const EscalationMonthlyReport = () => {
    
    const logout = useLogout();
    const navigate = useNavigate();
    const [ticketDetails, setTicketDetails] = useState(false);
    const axiosPrivate = useAxiosPrivate();
    const [filterError, setFilterError] = useState(false)
    const [month, setMonth] = useState("month");
    const [year, setYear] = useState("year");
    const currentYear = new Date().getFullYear(); 
    const startYear = 2022;
    const years = Array.from({ length: currentYear - startYear + 1 }, (_, i) => startYear + i);
    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    useEffect(() => {
        let isMounted = true;
        const controller = new AbortController();

        const getRecentEscalations = async () => {
            try {
                const response = await axiosPrivate.get('/mReport', {
                    signal: controller.signal
                });
                isMounted && setTicketDetails(response.data);
            } catch (err) {
                if (err.message !== 'canceled') {
                    await logout();
                    navigate('/login');
                }
            }
        }

        getRecentEscalations();

        return () => {
            isMounted = false;
            controller.abort();
        }
        // eslint-disable-next-line
    }, []);

    const handleFilter = async () => {
        try {
            setFilterError(false);
            if (year === 'year') {
                return setFilterError("Please select a valid Year");
            }
            getEscalationsTickets();
        } catch (err) {
            if (err.message !== 'canceled') {
                await logout();
            }
        }
    }

    const getEscalationsTickets = async () => {
        try {
            setTicketDetails(false);
            if (year === 'year' || month === 'month') {
                return setFilterError("Please select a valid Month and Year");
            }
            console.log("Selected month:", month);
            
            // const monthIndex = months.indexOf(month);
            // console.log("Month index:", monthIndex);
            // if (monthIndex === -1) {
            //     return setFilterError("Invalid month selected");
            // }
            const url = `/mReport?month=${month}&year=${year}`;
            console.log("Months and Year", month +" " +year);
            const response = await axiosPrivate.get(url);
            if (response.data.msg) return setTicketDetails({});
            setTicketDetails(response.data);
        } catch (err) {
            if (err.message !== 'canceled') {
                await logout();
            }
        }
    }
    


    return (
        <EscMonthlyReportTable 
            month={month} 
            handleFilter={handleFilter} 
            ticketDetails={ticketDetails} 
            setMonth={setMonth} 
            filterError={filterError} 
            years={years} 
            setYear={setYear} 
            months={months} 
        />
    );
}

export default EscalationMonthlyReport;
